import http from "../core/http";
const group = 'events';

export const getDataListRequest =  async (data) => {
    return await http.post(`${group}/get`, data).then(res => res.data).catch(http.defaultCatch);
}

// Public: used by the issuer FAQ modal and by the volunteer FAQ page, which is
// viewed without an account. Same unauthenticated pattern as the guest kit
// status lookup.
export const getActiveFaqRequest = async (data) => {
    return await http.post(`${group}/activeFaq`, data).then(res => res.data).catch(http.defaultCatch);
}

export const isDisplayedRequest =  async (data) => {
    return await http.post(`${group}/isDisplayed`, data).then(res => res.data).catch(http.defaultCatch);
}

export const createDataRequest =  async (data) => {
    return await http.post(`${group}/create`, data).then(res => res.data).catch(http.defaultCatch);
}

export const updateDataRequest =  async (data) => {
    return await http.post(`${group}/update`, data).then(res => res.data).catch(http.defaultCatch);
}

export const deleteDataRequest =  async (data) => {
    return await http.post(`${group}/delete`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getTeeTypeListRequest =  async (data) => {
    return await http.post(`${group}/getTeeTypeList`, data).then(res => res.data).catch(http.defaultCatch);
}
